import Layout from "@/components/Layout";
import PageHero from "@/components/PageHero";
import { Section, SectionLabel, SectionTitle, FadeIn } from "@/components/Section";
import { Shield, Users, ClipboardList, Lock, Anchor, Award } from "lucide-react";

const complianceCards = [
  { icon: Shield, title: "ISM Code", desc: "Full Safety Management System compliant with ISM Code Sections 1–13. Document of Compliance and Safety Management Certificate via RMI." },
  { icon: Users, title: "MLC 2006", desc: "Maritime Labour Convention compliance ensuring fair conditions, safe workplaces, proper accommodation, and health protection for all seafarers." },
  { icon: ClipboardList, title: "OVMSA / eCMID", desc: "Offshore Vessel Management Self Assessment and electronic Common Marine Inspection Document readiness. Audit-ready documentation suite." },
  { icon: Lock, title: "Cyber Security", desc: "Maritime cyber risk management aligned to IMO MSC.428(98). OT/IT segregation, access controls, incident response, and crew cyber awareness training." },
  { icon: Anchor, title: "MARPOL", desc: "Full compliance with MARPOL Annexes I through VI. SOPEP, Garbage Management Plan, and SEEMP documentation maintained current." },
  { icon: Award, title: "Quality Management", desc: "ISO 9001-aligned QMS with documented procedures, internal audit programme, management review, and continuous improvement KPI tracking." },
];

const certBadges = ["ABS Classification", "RMI Flag State", "STCW Certified Crew", "ISPS Code Compliant", "MARPOL Annex I–VI", "ISO 9001 Aligned QMS"];

const Safety = () => (
  <Layout>
    <PageHero
      tag="Safety & Compliance"
      title={<>Zero harm. <span className="accent-text">No compromise.</span></>}
      subtitle="Our Safety Management System is built from the ground up to meet the highest standards demanded by major operators worldwide."
    />

    <Section>
      <SectionLabel>Compliance Framework</SectionLabel>
      <SectionTitle>Industry-leading <span className="accent-text">standards</span></SectionTitle>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-12">
        {complianceCards.map((card, i) => (
          <FadeIn key={card.title} delay={i * 0.08}>
            <div className="bg-card rounded-2xl p-8 border border-border hover-lift group relative overflow-hidden">
              <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-teal to-lime opacity-0 group-hover:opacity-100 transition-opacity" />
              <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-teal/10 to-lime/10 flex items-center justify-center mb-5 group-hover:from-teal/20 group-hover:to-lime/20 transition-colors">
                <card.icon className="w-6 h-6 text-teal" />
              </div>
              <h3 className="font-display text-lg text-navy tracking-tight mb-3">{card.title}</h3>
              <p className="text-text-light font-body text-sm leading-relaxed">{card.desc}</p>
            </div>
          </FadeIn>
        ))}
      </div>
    </Section>

    <Section dark>
      <div className="text-center">
        <SectionLabel>Certifications</SectionLabel>
        <SectionTitle light>Certified to the <span className="accent-text">highest standards</span></SectionTitle>
        <div className="flex flex-wrap justify-center gap-4 mt-10">
          {certBadges.map((badge, i) => (
            <FadeIn key={badge} delay={i * 0.06}>
              <div className="flex items-center gap-3 px-6 py-3 rounded-full glass-card">
                <div className="w-2 h-2 bg-gradient-to-br from-teal to-lime rounded-full" />
                <span className="text-primary-foreground/70 font-body text-sm">{badge}</span>
              </div>
            </FadeIn>
          ))}
        </div>
      </div>
    </Section>
  </Layout>
);

export default Safety;
